import orderAPI from "../../../api/orderApi";
import { useSiteConfig } from "../../../context/SiteConfigContext";
import { showError, showSuccess } from "../../../utils/toastUtils";

class RazorpayService {
  pay({
    gatewayOrderId,
    orderId,
    amount,
    currency,
    formData,
    navigate,
    config,
    fetchCart
  }) {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: amount,
      currency: currency,
      name: config?.name,
      image: config?.logo,
      description: "Order Payment",
      order_id: gatewayOrderId,
      prefill: {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        contact: formData.phone,
      },
      notes: {
        orderId,
        customerEmail: formData.email,
        customerPhone: formData.phone,
      },
      handler: async function (response) {
        try {
          const verifyRes = await orderAPI.paymentConfirmed({
            payload: {
              razorpayPaymentId: response.razorpay_payment_id,
            },
            orderId,
            gateway: "razorpay",
          });

          if (verifyRes.code === 200) {
            showSuccess("Payment successful!");

            await fetchCart();

            sessionStorage.setItem("orderId", orderId);
            navigate("/order-confirmation");
          } else {
            showError("Payment verification failed");
          }
        } catch {
          showError("Payment verification error");
        }
      },

      modal: {
        ondismiss: async () => {
          try {
            const result = await orderAPI.paymentCancelled({
              orderId,
              gateway: "razorpay",
            });

            if (result.code === 200) {
              sessionStorage.removeItem("orderId");
              showError(result.message);
            }
          } catch (err) {
            console.error(err);
            showError("Cancel failed");
          }
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  }
}

export default RazorpayService;
